import styled, { css } from 'styled-components';

import { mediaBreakpoint } from '../../../utils/mediaBreakpoint';
import { Layout } from '../../../types';

const DescList = styled.dl<{ layout: Layout }>`
    ${(props) =>
        props.layout === 'grid' ? 
            css`
            ${mediaBreakpoint.up('md')} {
                display: grid;
                grid-template-columns: 194px auto;
                column-gap: ${({ theme }) => theme.Spacing.spacing3x};
            }
        ` : null }
`;

export default DescList;
